import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import { dashboardInfoMock } from './mock';
import { coursePath } from '../../utils/paths';

export default {
  dashboardInfo: () => {
    if (shouldUseMock()) {
      return dashboardInfoMock();
    }
    return apiCall(`${baseUrl}${coursePath}statistics/user/courses`, 'GET');
  },
};
